export default {
    csManagement: {
        page: {
            title: 'CS管理センター',
            description: 'テナントクォータ、ドキュメント総量、Token消費の管理',
        },
        quota: {
            searchPlaceholder: 'テナントIDで検索',
            typePlaceholder: 'クォータタイプ',
            search: '検索',
            create: 'クォータ追加',
            tenantId: 'テナントID',
            quotaType: 'クォータタイプ',
            typeDocument: 'ドキュメント総量',
            typeToken: 'Token消費総量',
            quotaLimit: '上限',
            quotaUsed: '使用済み',
            contractPeriod: '契約期間',
            contractStart: '契約開始',
            contractEnd: '契約終了',
            status: 'ステータス',
            statusActive: '有効',
            statusExpired: '期限切れ',
            remark: '備考',
            action: '操作',
            edit: '編集',
            delete: '削除',
            createTitle: 'クォータ追加',
            editTitle: 'クォータ編集',
            cancel: 'キャンセル',
            confirm: '確認',
            saving: '保存中...',
            featureConfig: '機能設定',
            featureConfigTitle: '機能権限設定',
            featureQuotaSectionTitle: '機能回数上限',
            featureQuotaSectionDesc: '契約期間中に各機能で作成できる回数を設定します。-1 は無制限、0 は機能無効を表します。',
            featureDisclosure: '発明開示書',
            featureDisclosureLimit: '発明開示書上限',
            featureDisclosureDesc: '発明開示書作成機能',
            featurePatentDraft: '特許出願',
            featurePatentDraftLimit: '特許出願上限',
            featurePatentDraftDesc: '特許出願書類作成機能',
            featureProsecution: 'OAR応答',
            featureProsecutionLimit: 'OAR応答上限',
            featureProsecutionDesc: '審査意見応答作成機能',
            featureLimitHint: '* -1 は無制限、0 は機能無効を表します',
            featureLimitExceeded: '機能回数の合計 {total} は上限 {limit} を超えられません',
            featureUsed: '使用済み',
            featureRemaining: '残り',
            featureReachedLimit: '上限に達しました',
            featureLimitBelowUsedWarning: '上限が使用済み回数を下回っています',
            featureDisabled: '無効',
            userQuotaTitle: 'ユーザークォータ詳細',
            userQuotaHint: '会社クォータ上限：{limit} 回',
            userEmail: 'ユーザーメール',
            unlimited: '無制限',
            addUser: 'ユーザー追加',
            addUserPlaceholder: 'メールアドレスを入力',
            reset: 'クリア',
            deleteUserQuotaConfirmTitle: 'このユーザーの個人クォータ設定を削除しますか？',
            deleteUserQuotaConfirmDesc: '削除後、このユーザーはユーザークォータ詳細に表示されず、個人機能回数制限は未設定の状態に戻ります。',
            tenantName: '会社名',
            configuredMembers: '設定済みメンバー',
            noConfiguredMembers: 'この会社には設定済みメンバーがいません',
            tenantInfoNotFound: '会社が見つかりません',
            tenantInfoFailed: '取得に失敗しました。後でもう一度お試しください',
            featureList: '機能一覧',
            featureAll: 'すべて',
        },
    },
};
